/**
 * Always-on UI glue. Heavy libs stay in vendor.js; smooth scroll is bridged after theme.js assigns window.themeKit.smoothScroll.
 */
window.themeKit = window.themeKit || {};

function themeKitSmoothScroll(state) {
  var fn = window.themeKit.smoothScroll;
  if (typeof fn === 'function') fn(state);
}

function fadeOut(element, duration) {
  var start = performance.now();

  function animate(currentTime) {
    var elapsed = currentTime - start;
    var progress = elapsed / duration;

    element.style.opacity = Math.max(1 - progress, 0);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.display = 'none';
    }
  }

  requestAnimationFrame(animate);
}

function fadeIn(element, duration, type) {
  element.style.display = type;
  element.style.opacity = 0;
  var start = performance.now();

  function animate(currentTime) {
    var elapsed = currentTime - start;
    var progress = elapsed / duration;

    element.style.opacity = Math.min(progress, 1);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

function triggerOverlay() {
  var overlay = document.querySelector('#mainOverlay');

  if (overlay) {
    var html = document.querySelector('html');
    var body = document.querySelector('body');
    if (document.querySelectorAll('.popup.active').length > 0) {
      overlay.classList.add('active');
      body.style.overflow = 'visible';
      html.style.overflow = 'hidden';
      if (window.innerWidth > 768) {
        html.style.marginRight = '8px';
      }
      themeKitSmoothScroll('stop');
    } else {
      overlay.classList.remove('active');
      body.style.removeProperty('overflow');
      html.removeAttribute('style');
      themeKitSmoothScroll('play');
    }
  }
}

var popupPreviousFocus = null;

function isPopupDialog(el) {
  return !!(el && el.classList && el.classList.contains('popup'));
}

function getPopupFocusable(container) {
  return Array.prototype.slice
    .call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    )
    .filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
}

function getTopActivePopup() {
  var active = document.querySelectorAll('.popup.active');
  return active.length ? active[active.length - 1] : null;
}

function ensurePopupDialogAttrs(el) {
  if (!el.hasAttribute('role')) el.setAttribute('role', 'dialog');
  el.setAttribute('aria-modal', 'true');
  if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
    var title = el.querySelector('.titles .s1, .menu-head.popup-head, [data-dialog-title], .h4.locale-detection');
    if (title) {
      if (!title.id) {
        title.id = 'DialogTitle-' + Math.random().toString(36).slice(2, 9);
      }
      el.setAttribute('aria-labelledby', title.id);
    }
  }
}

function announceCartDrawer(message) {
  var live = document.querySelector('.main-cart-drawer [data-cart-drawer-live]');
  if (!live || !message) return;
  live.textContent = '';
  requestAnimationFrame(function () {
    live.textContent = message;
  });
}

function activatePopupA11y(el) {
  if (!isPopupDialog(el)) return;
  ensurePopupDialogAttrs(el);
  el.setAttribute('aria-hidden', 'false');
  if (!el.contains(document.activeElement)) {
    popupPreviousFocus = document.activeElement;
  }
  var closeBtn = el.querySelector(
    '[data-cart-drawer-close], [data-dialog-close], button.close, .search-drawer-dewalt__close'
  );
  var focusables = getPopupFocusable(el);
  var target = closeBtn || focusables[0] || el;
  if (target && typeof target.focus === 'function') {
    requestAnimationFrame(function () {
      target.focus();
    });
  }
}

function deactivatePopupA11y(el) {
  if (!isPopupDialog(el)) return;
  el.setAttribute('aria-hidden', 'true');
  var live = el.querySelector('[data-cart-drawer-live]');
  if (live) live.textContent = '';
  if (popupPreviousFocus && typeof popupPreviousFocus.focus === 'function') {
    popupPreviousFocus.focus();
  }
  popupPreviousFocus = null;
}

function hide(el) {
  if (!el) return;
  var wasPopup = isPopupDialog(el) && el.classList.contains('active');
  el.classList.remove('active');
  if (wasPopup) deactivatePopupA11y(el);
}

function show(el) {
  if (!el) return;
  el.classList.add('active');
  if (isPopupDialog(el)) activatePopupA11y(el);
}

function openCartDrawer(options) {
  options = options || {};
  var drawer = document.querySelector('.main-cart-drawer');
  if (!drawer) return;
  show(drawer);
  triggerOverlay();
  if (options.announceAdded) {
    announceCartDrawer(drawer.getAttribute('data-item-added'));
  }
}

function closeCartDrawer() {
  var drawer = document.querySelector('.main-cart-drawer');
  if (!drawer || !drawer.classList.contains('active')) return;
  hide(drawer);
  triggerOverlay();
}

function closeActivePopup() {
  var drawer = getTopActivePopup();
  if (!drawer) return;

  if (drawer.classList.contains('menu-wrapper')) {
    var menus = drawer.querySelectorAll('.first-level-wrapper');
    menus.forEach(function (menu) {
      menu.classList.remove('active');
    });
    var secondLevel = drawer.querySelector('.second-level');
    if (secondLevel) fadeOut(secondLevel, 300);
  }

  hide(drawer);
  triggerOverlay();
}

function toggle(el) {
  el.classList.toggle('active');
}

function easeOut(t) {
  return t * (2 - t);
}

function overlayClose() {
  var overlay = document.querySelector('#mainOverlay');
  if (overlay) {
    overlay.addEventListener('click', function () {
      var activePopups = document.querySelectorAll('.popup.active');
      var menuWrapper = document.querySelector('.main-menu-drawer .menu-wrapper');
      var html = document.querySelector('html');
      var body = document.querySelector('body');
      if (menuWrapper) {
        var menus = menuWrapper.querySelectorAll('.first-level-wrapper');
        menus.forEach(function (e) {
          e.classList.remove('active');
        });
        var secondLevel = menuWrapper.querySelector('.second-level');
        fadeOut(secondLevel, 300);
      }
      activePopups.forEach(function (e) {
        hide(e);
      });
      hide(overlay);
      html.removeAttribute('style');
      body.style.removeProperty('overflow');
      themeKitSmoothScroll('play');
    });
  }
}

document.addEventListener('keydown', function (e) {
  var drawer = getTopActivePopup();
  if (!drawer) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    closeActivePopup();
    return;
  }

  if (e.key !== 'Tab') return;

  var focusables = getPopupFocusable(drawer);
  if (!focusables.length) {
    e.preventDefault();
    var fallback = drawer.querySelector(
      '[data-cart-drawer-close], [data-dialog-close], button.close, .search-drawer-dewalt__close'
    );
    if (fallback) fallback.focus();
    return;
  }

  var first = focusables[0];
  var last = focusables[focusables.length - 1];
  var active = document.activeElement;

  if (e.shiftKey) {
    if (active === first || !drawer.contains(active)) {
      e.preventDefault();
      last.focus();
    }
  } else if (active === last || !drawer.contains(active)) {
    e.preventDefault();
    first.focus();
  }
});

function debounce(func, delay) {
  var timeoutId;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}

/** Shopify money format helper (used by section scripts). */
function formatMoney(cents, format) {
  if (format === undefined) format = '';
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  }
  return formatString.replace(placeholderRegex, value);
}

overlayClose();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.popup').forEach(function (popup) {
    ensurePopupDialogAttrs(popup);
    if (!popup.classList.contains('active')) {
      popup.setAttribute('aria-hidden', 'true');
    }
  });
});
